
export default {
    inject: ['EventBus', 'PIXIWrapper'],

    props: {
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        anchorX: {
            type: Number,
            default: 0
        },
        anchorY: {
            type: Number,
            default: 0
        },
        alpha: {
            type: Number,
            default: 1
        },
        spriteName: {
            type: String,
            required: true
        },
        spriteDirectory: {
            type: String,
            required: true
        },
        numFrames: {
            type: Number,
            required: true
        },
        scale: {
            type: Number,
            default: 1
        },
        width: {
            type: Number
        },
        height: {
            type: Number
        },
        zIndex: {
            type: Number
        },
        interactive: {
            type: Boolean,
            default: true
        }
    },

    data () {
        return {
            loader: null,
            sprite: null,
            container: null
        };
    },

    watch: {
        alpha () {
            this.sprite.alpha = this.alpha;
        }
    },

    created () {
        this.container = this.$game.getParentPIXIContainer(this);

        let path = `${ this.spriteDirectory }${ this.spriteName }.json`;
        this.loader = new this.PIXIWrapper.PIXI.Loader();
        this.PIXIWrapper.LoaderManager.add(this, this.draw, path);
    },

    destroyed () {
        if (this.sprite !== null && !this.sprite._destroyed) {
            this.sprite.destroy(true);
        }
    },

    methods: {
        /**
         * Draw the container.
         */
        draw () {
            let frames = [];
            for (let i = 1; i < this.numFrames + 1; i++) {
                frames.push(this.PIXIWrapper.PIXI.Texture.from(`${this.spriteName}_${ i }.png`));
            }

            this.sprite = new this.PIXIWrapper.PIXI.AnimatedSprite(frames);

            this.sprite.x = this.x;
            this.sprite.y = this.y;

            this.sprite.alpha = this.alpha;

            this.sprite.scale.set(this.scale);

            if (this.width !== undefined) {
                this.sprite.width = this.width;
            }

            if (this.height !== undefined) {
                this.sprite.height = this.height;
            }

            if (this.zIndex !== undefined) {
                this.sprite.zIndex = this.zIndex;
            }

            this.sprite.anchor.set(this.anchorX, this.anchorY);

            this.sprite.play();

            if (this.interactive) {
                this.defineEvents();
            }

            // Add the sprite to the parent container or the root app stage.
            if (this.container) {
                this.container.addChild(this.sprite);
            } else {
                this.PIXIWrapper.app.stage.addChild(this.sprite);
            }
        },

        /**
         * Define all pixi events that should be emitted ($emit) to the parent component.
         * Only events that are used in parent component ($listeners) will be attached.
         */
        defineEvents () {
            let eventList = [
                'added',
                'click',
                'mousedown',
                'mousemove',
                'mouseout',
                'mouseover',
                'mouseup',
                'mouseupoutside',
                'pointercancel',
                'pointerdown',
                'pointermove',
                'pointerout',
                'pointerover',
                'pointertap',
                'pointerup',
                'pointerupoutside',
                'removed',
                'rightclick',
                'rightdown',
                'rightup',
                'rightupoutside',
                'tap',
                'touchcancel',
                'touchend',
                'touchendoutside',
                'touchmove',
                'touchstart'
            ];

            this.sprite.interactive = true;

            eventList
                .filter(eventName => Object.keys(this.$listeners).includes(eventName))
                .forEach(eventName => {
                    this.sprite.on(eventName, (event) => {
                        this.$emit(eventName, {
                            element: this.sprite,
                            event,
                            AnimationManager: this.PIXIWrapper.AnimationManager
                        });
                    });
                });
        }
    },

    render: (h) => h()
};
